import { pickBy } from 'lodash';
import { JsonTsMapper } from 'json-ts-mapper';

export class ApiUtils {
  static responseParser(request: Promise<unknown>): Promise<unknown>;
  static responseParser<T>(request: Promise<unknown>, mapToClass: {new():T}): Promise<T> ;
  static responseParser<T>(request: Promise<unknown>, mapToClass: { new(): T }[]): Promise<T[]> ;
  static responseParser<T> (request: Promise<unknown>, mapToClass?: { new(): T } | { new(): T }[]): Promise<any> {
    const data = request.then((response:any) => {
      if (mapToClass !== undefined) {
        // console.log('api', response, JsonTsMapper.deserialize(response.data, Array.isArray(mapToClass) ? mapToClass[0] : mapToClass));
        return JsonTsMapper.deserialize(response.data, Array.isArray(mapToClass) ? mapToClass[0] : mapToClass);
      } else {
        if (Array.isArray(response.data)) {
          return response.data;
        } else {
          const _data = Object.assign({}, response.data);

          return _data;
        }
      }
    });
    Object.defineProperty(data, '$response', { value: request });

    return data as any;
  }

  static buildQueryParamsStr (params: { [key: string]: number|boolean|string }):string {
    params = pickBy(params, (i:any) => i !== undefined && i !== null);
    let paramsStr = Object.keys(params).map(k => k + '=' + params[k]).join('&');
    paramsStr = paramsStr ? '?' + paramsStr : '';

    return paramsStr;
  }
}
